<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>{{ data.searchNameTitle }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="form-item">
                <mat-form-field class="mat-form-field-text">
                    <mat-label>Texte</mat-label>
                    <textarea matInput rows="6" [formControl]="searchTextFormControl" autocomplete="off" required></textarea>
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="search()" [disabled]="!searchTextFormControl.valid">Rechercher</button>
    </mat-card-actions>
</mat-card>
